import { Icon } from "antd";

const ProductList = ({ products = [] }) => {
    return (
        <div style={{ marginTop: '32px' }}>
            <h4 style={{
                fontSize: '16px',
                fontWeight: 'bold',
                marginBottom: '16px',
                display: 'flex',
                alignItems: 'center',
                gap: '8px'
            }}>
                <Icon type="shopping" />
                Productos ({products.length})
            </h4>
            {products.map((product, index) => (
                <div key={index} style={{
                    padding: '12px 0',
                    borderBottom: index < products.length - 1 ? '1px solid #f0f0f0' : 'none',
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    gap: '12px'
                }}>
                    <div style={{ flex: 1 }}>
                        <div style={{ fontWeight: '600' }}>{product.pro_nombre_completo}</div>
                        <div style={{ fontSize: '12px', color: '#666' }}>
                            EAN: {product.prv_codigo_barra || 'N/A'}
                        </div>
                    </div>
                    <div style={{ fontWeight: '600', fontSize: '16px' }}>
                        x{product.quantity}
                    </div>
                </div>
            ))}
        </div>
    );
};

export default ProductList;
